// @ts-nocheck
import * as actions from './tpaActions';
import * as tpaSelectors from './tpaSelectors';

export { actions, tpaSelectors as selectors };
